import { DialogTitle } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import Button from "components/buttons/Button";
import Modal from "components/modal/Modal";
import { useTranslation } from "react-i18next";
import { AcceptOrRejectMultipleOffersResponseDto } from "../../offer.typing";

interface Props {
  show: boolean;
  error: AcceptOrRejectMultipleOffersResponseDto;
  onClose: () => void;
  type?: "accept" | "decline";
}

const ErrorModal = ({ show, error, onClose, type = "accept" }: Props) => {
  const { t } = useTranslation();

  const validationErrors = error.validationErrors || [];
  const errors = error.errors || [];

  // Extract all task codes from both arrays
  const taskCodes = [...validationErrors, ...errors].map((e) => e.code);

  const messageKey = type === "decline" ? "offer.modal.declineFailure" : "offer.modal.acceptanceFailure";

  return (
    <Modal isShown={show} onClose={onClose}>
      <div>
        {/*Icon*/}
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100">
          <ExclamationTriangleIcon className="size-6 text-red-600" aria-hidden="true" />
        </div>
        {/*Header*/}
        <div className="mt-3 text-center sm:mt-5">
          <DialogTitle as="h3" className="text-color-primary text-lg font-medium leading-6 sm:text-3xl">
            {t("error:common.error")}
          </DialogTitle>
        </div>

        {/*body*/}
        <div className="mx-4 mt-6 flex flex-col space-y-4">
          <div className="text-color-secondary text-sm">{t(messageKey)}</div>
          {taskCodes.length > 0 && (
            <div className="rounded-md bg-red-50 p-4">
              <ul className="space-y-1">
                {taskCodes.map((code, index: number) => (
                  <li key={index} className="text-sm text-red-700">
                    • {code}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/*Footer*/}
        <div className="mt-6 flex justify-end">
          <Button color="primary" label={t("common.actions.close")} onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
